export default {"src":"/_next/static/media/carTag.82fdb954.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};